import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './sidebar.css';
import axios from 'axios';
import { API_URL, baseurl } from '../../../_config';
import { ShopContext } from '../../../Context/ShopContext';

const SideBar = () => {
    const location = useLocation();
    const [openMenu, setOpenMenu] = useState(null);
    const storedUserData = sessionStorage.getItem('userData');
    const userData = storedUserData ? JSON.parse(storedUserData) : null;
    const [menu, setMenus] = useState([]);
    const {
        toggleMenu,
        setToggleMenu
    } = useContext(ShopContext);

    // Access role safely
    const role = userData?.role;

    const handleItemClick = (index, item) => {
        sessionStorage.setItem("activeItems", index);
        sessionStorage.setItem("activeItemsUrl", item?.url);
        setToggleMenu(false);
    };

    const storedActiveItem = sessionStorage.getItem("activeItems");
    const activeItems = storedActiveItem !== null ? Number(storedActiveItem) : null;

    const toggleDropdown = (index) => {
        setOpenMenu((current) => current === index ? null : index);
    };

    const [activeSubmenu, setActiveSubmenu] = useState(
        sessionStorage.getItem("activeSubmenu") || ""
    );

    const handleSubMenuClick = (parentIndex, subIndex) => {
        const key = `${parentIndex}-${subIndex}`;
        sessionStorage.setItem("activeSubmenu", key);
        setActiveSubmenu(key);
    };

    const getMenus = useCallback(async () => {
        if (!role) {
            setMenus([]);
            return;
        }

        try {
            const response = await axios.get(`${baseurl}${API_URL.getMenusByRole}`, {
                params: { roleId: role }
            });

            if (response?.data?.isSuccess === 1) {
                setMenus(Array.isArray(response?.data?.data) ? response.data.data : []);
            } else {
                setMenus([]);
            }
        } catch {
            setMenus([]);
        }
    }, [role]);

    useEffect(() => {
        getMenus();
        window.addEventListener('menus-updated', getMenus);
        return () => window.removeEventListener('menus-updated', getMenus);
    }, [getMenus]);

    useEffect(() => {
        const activeParentIndex = menu.findIndex((item) => item.children?.some((child) => (
            location.pathname === child.url ||
            location.pathname.startsWith(`${child.url}/`)
        )));
        setOpenMenu(activeParentIndex === -1 ? null : activeParentIndex);
    }, [menu, location.pathname]);

    return (
        <>
            <div className={`sidebar ${!toggleMenu ? 'closeSidebar' : 'open'}`} pb-3>
                <nav className="navbar  navbar-dark sidebarcontent">
                    <div className="navbar-brand mx-4 mb-2 pt-3 d-flex align-items-sm-center justify-content-md-center justify-content-between w-100">
                        <h3 className="text-primary sidebar-logo">
                            <img src={`../../images/logonew.webp`} alt='' />
                        </h3>
                        <span className='cross_toggle_icon' onClick={() => setToggleMenu(false)}>
                            <svg
                                id="Bold"
                                viewBox="0 0 24 24"
                                width='30'
                                height='30'
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g width="100%" height="100%" transform="matrix(1,0,0,1,0,0)">
                                    <path
                                        d="M14.121,12L18,8.117A1.5,1.5,0,0,0,15.883,6L12,9.879,8.11,5.988A1.5,1.5,0,1,0,5.988,8.11L9.879,12,6,15.882A1.5,1.5,0,1,0,8.118,18L12,14.121,15.878,18A1.5,1.5,0,0,0,18,15.878Z"
                                        fill='#ffffff'
                                    />
                                </g>
                            </svg>
                        </span>
                    </div>
                    <div className="navbar-nav w-100">
                        {menu
                            .map((item, i) => {
                                const isParentActive =
                                    activeItems === i ||
                                    location.pathname === item.url ||
                                    item.children?.some((child) => (
                                        location.pathname === child.url ||
                                        location.pathname.startsWith(`${child.url}/`)
                                    ));

                                return (
                                <React.Fragment key={item.id || i}>
                                        <div className="nav-item dropdown side_bar_svg">
                                                <Link
                                                    to={item.url}
                                                    aria-expanded={item.children?.length > 0 ? openMenu === i : undefined}
                                                    onClick={(e) => {
                                                        if (item.children?.length > 0) {
                                                            e.preventDefault();
                                                            toggleDropdown(i);
                                                        } else {
                                                            handleItemClick(i, item);
                                                        }
                                                    }}
                                                    className={`nav-link ${isParentActive ? 'active' : ''}`}

                                                >
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className='d-flex align-items-center' style={{ gap: "10px" }}>
                                                            <i className={item.icon}></i>
                                                            <span>{item.title}</span>
                                                        </div>
                                                        {item?.children?.length > 0 && (
                                                            <div className='d-flex align-items-center'>
                                                                <svg width="15" height="12" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg" className={`arrow mb-0 ${openMenu === i ? 'rotate' : ''}`}>
                                                                    <path d="M4 0.75L7.182 3.932L6.121 4.992L4 2.871L1.879 4.992L0.818 3.932L4 0.75Z" fill="#747684" />
                                                                </svg>
                                                            </div>
                                                        )}
                                                    </div>
                                                </Link>

                                            {item.children?.length > 0 && (
                                                <div
                                                    className={`sidebar-submenu ${openMenu === i ? 'is-open' : ''}`}
                                                    aria-hidden={openMenu !== i}
                                                >
                                                <div className="sidebar-submenu-inner">
                                                <div className="dropdown-content sub-menu-bg">
                                                    {item?.children?.map((subItem, j) => (
                                                        <Link
                                                            key={subItem.id || j}
                                                            to={subItem.url}
                                                            tabIndex={openMenu === i ? undefined : -1}
                                                            onClick={() => handleSubMenuClick(i, j)}
                                                            className={`dropdown-item submenu-item ${activeSubmenu === `${i}-${j}` || location.pathname === subItem.url ? 'active-submenu' : ''}`}
                                                        >
                                                            {subItem.title}
                                                        </Link>
                                                    ))}
                                                </div>
                                                </div>
                                                </div>
                                            )}
                                        </div>
                                </React.Fragment>
                            )})}

                    </div>
                </nav >
            </div >
        </>
    )
}

export default SideBar;
